import { Link } from "react-router-dom";

const industries = [
  {
    id: "law-firms",
    image: "https://public.readdy.ai/ai/img_res/8d0cfb85de2d94d02e7ad45ee4e058ff.jpg",
    alt: "Law Firms",
    icon: "ri-scales-3-line",
    subtitle: "For law firms and legal practices",
    title: "Law Firms",
    description:
      "Your lawyers should be winning cases, not chasing documents or manually scheduling consultations. AI automation handles the rest so your team can focus on what matters.",
    stats: [
      { value: "70%", label: "Reduction in document review time" },
      { value: "3x", label: "Faster client intake processing" },
      { value: "40%", label: "Fewer missed appointments" },
    ],
    href: "/solutions#law-firms",
    linkText: "See Law Firms solutions",
  },
  {
    id: "consulting-firms",
    image: "https://public.readdy.ai/ai/img_res/3583de438998c8d54d2f8f28aa1c50c4.jpg",
    alt: "Consulting Firms",
    icon: "ri-bar-chart-box-line",
    subtitle: "For consulting firms and advisory practices",
    title: "Consulting Firms",
    description:
      "Consultants are paid for insight, not administration. AI automation takes care of the scheduling, document prep, and knowledge management so you can deliver more value to clients.",
    stats: [
      { value: "50%", label: "Less time on administrative tasks" },
      { value: "2x", label: "Faster proposal turnaround" },
      { value: "90%", label: "Client query resolution rate" },
    ],
    href: "/solutions#consulting-firms",
    linkText: "See Consulting Firms solutions",
  },
  {
    id: "manufacturing",
    image: "https://readdy.ai/api/search-image?query=modern%20manufacturing%20facility%20clean%20industrial%20environment%20workers%20using%20digital%20tablets%20automated%20production%20line%20sophisticated%20factory%20floor%20professional%20industrial%20setting&width=800&height=600&seq=manufacturing-01&orientation=landscape",
    alt: "Manufacturing Companies",
    icon: "ri-settings-4-line",
    subtitle: "For mid-sized manufacturing businesses",
    title: "Manufacturing Companies",
    description:
      "Manufacturing businesses face unique pressure — managing complex supplier relationships, compliance documents, and internal processes. AI automation keeps everything running smoothly.",
    stats: [
      { value: "60%", label: "Faster compliance document processing" },
      { value: "4hrs", label: "Saved per employee per week" },
      { value: "80%", label: "Faster new staff onboarding" },
    ],
    href: "/solutions#manufacturing",
    linkText: "See Manufacturing Companies solutions",
  },
];

export default function IndustrySolutions() {
  return (
    <section className="py-24 bg-[#070C18]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-electric-400 text-xs font-semibold uppercase tracking-widest">Industry Solutions</span>
          <h2 className="mt-3 text-4xl lg:text-5xl font-extrabold text-white leading-tight">
            Built for Your{" "}
            <span className="text-electric-400">Industry</span>
          </h2>
          <p className="mt-4 text-slate-400 text-lg">We know your business. Which is why our AI fits right in.</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {industries.map((industry) => (
            <div key={industry.id} className="group relative overflow-hidden rounded-2xl cursor-pointer">
              <div className="h-56 overflow-hidden">
                <img
                  alt={industry.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  src={industry.image}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#070C18] via-[#070C18]/60 to-transparent"></div>
              </div>

              <div className="relative bg-[#0D1628] border border-white/8 group-hover:border-electric-500/30 rounded-b-2xl p-6 transition-all duration-300 -mt-1">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-electric-500/15 shrink-0">
                    <i className={`${industry.icon} text-electric-400 text-lg`}></i>
                  </div>
                  <div>
                    <p className="text-slate-400 text-xs">{industry.subtitle}</p>
                    <h3 className="text-white font-bold text-lg leading-tight">{industry.title}</h3>
                  </div>
                </div>

                <p className="text-slate-400 text-sm leading-relaxed mb-4">{industry.description}</p>

                <div className="grid grid-cols-3 gap-2 mb-5">
                  {industry.stats.map((stat) => (
                    <div key={stat.value} className="text-center p-2 rounded-xl bg-white/5">
                      <p className="text-electric-400 font-bold text-base">{stat.value}</p>
                      <p className="text-slate-500 text-xs leading-tight mt-0.5">{stat.label}</p>
                    </div>
                  ))}
                </div>

                <Link
                  className="inline-flex items-center gap-1.5 text-electric-400 text-sm font-semibold hover:gap-2.5 transition-all duration-200 whitespace-nowrap"
                  to={industry.href}
                >
                  {industry.linkText} <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
